
//
document.querySelectorAll('div[data-name="ikea-service-information"]').forEach((element) => {

    //
    element.querySelector('button[data-action="show-interest-form"]').addEventListener('click', (event) => {
        element.querySelector('[data-name="confirm"]').toggleAttribute('hidden');
    });

    //
    element.querySelector('button[data-action="request-callback"]').addEventListener('click', async (event) => {

        //
        const zenoFetch = require('../utils/zenoFetch.js');

        //
        const [status, response] = await zenoFetch('post', '/api/request-ikea-callback');

        //
        if (status == 'success') {
            element.querySelector('[data-name="callback-request-successful"]').removeAttribute('hidden');
        } else {
            element.querySelector('[data-name="callback-request-failed"]').removeAttribute('hidden');
        }

    });

});